import * as React from 'react';
import { BackNextSkip, TInvestmentReturn } from '@assetmark/common-elements/';
import { currencyFormatterWithDecimals } from '@assetmark/utilities/';
import {
  ProgressBarComponent,
  TInvestmentReturnProgressProps,
} from '@assetmark/common-elements';
import './investmentReturn.style.css';
import { TAssessRiskProfile } from '../models/assessRiskProfile.model';
import { TRiskChoice } from '../models/riskChoice.model';
// import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

export interface TInvestmentReturnProps {
  /** Array of Gain loss data */
  invesetmentRangeData?: TAssessRiskProfile[];
  /** Is investment return  selected */
  barRangeSelected: number;
  /** Total Investment Amount */
  investmentAmount?: number;
  /** Risk Choice array */
  choices?: TRiskChoice[];
  /** Next button click event handler */
  onNextButtonClick: (event: any) => void;
  /** Back button click event handler */
  onBackButtonClick: (event: any) => void;
  /** Skip button click event handler */
  onSkipButtonClick?: (event: any) => void;
}

export interface TInvestmentReturnState {
  barRangeSelected: number;
}

export interface TInvestmentReturnRangeData {
  allSeries?: TInvestmentReturn[];
  seriesReturns: TInvestmentReturn;
}

export class InvestmentReturnComponent extends React.Component<
  TInvestmentReturnProps,
  TInvestmentReturnState
> {
  constructor(props?: TInvestmentReturnProps, context?: any) {
    super(props, context);

    // const riskDetails = this.props.risk.risk;
    this.state = {
      barRangeSelected: this.props.barRangeSelected,
    };

    // this.props.onBackButtonClick = this.props.onBackButtonClick.bind(this);
    // this.onNextButtonClick = this.onNextButtonClick.bind(this);
    // this.goToRiskClick = this.goToRiskClick.bind(this);
  }

  public render() {
    // displaying models from helper
    if (!this.props) {
      return null;
    }

    const choices = this.props && this.props.choices ? this.props.choices : [];
    const investmentReturnModels = this.getInvestmentReturnModelsFromChoices(
      this.props.investmentAmount,
      this.props.invesetmentRangeData,
      choices,
    );

    // const selected = (!this.state.barRangeSelected) ? this.props.data.selectedChoiceId : this.state.barRangeSelected;
    const selected = this.state.barRangeSelected;

    return (
      <div className="investment-return-range-component col-sm-12">
        <h1 className="investment-return-range-title">
          Investment Return Range
        </h1>
        <p className="label-text">
          During any 12 month period, returns on portfolios with exposure to the
          stock market can vary dramatically. Given this variability and your
          initial investment of ${' '}
          {currencyFormatterWithDecimals(this.props.investmentAmount)}, please
          select the typical range of potential gains and losses with which you
          are most comfortable.*
        </p>
        <div className="container-fluid mt-4">
          <div className="row mt-row return-bar-charts">
            <div className="col-sm-2 initial-investment">
              <div className="top">
                <h3>INITIAL INVESTMENT</h3>
                <p>
                  $ {currencyFormatterWithDecimals(this.props.investmentAmount)}
                </p>
              </div>
            </div>
            <div className="col-sm-10">
              <div className="row">
                {investmentReturnModels.map((model, index) => {
                  return (
                    <div
                      className={`col-2 bar ${
                        selected === model.Key ? 'selected' : ''
                      }`}
                      key={index}
                      onClick={this.selectInvestmentRange.bind(this, model.Key)}
                    >
                      <ProgressBarComponent
                        height={340}
                        investmentAmount={this.props.investmentAmount}
                        allSeries={investmentReturnModels}
                        seriesReturns={model}
                      />
                      <a
                        onClick={this.selectInvestmentRange.bind(
                          this,
                          model.Key,
                        )}
                        className={
                          selected === model.Key
                            ? 'hidden select-return-range'
                            : 'select-return-range'
                        }
                      >
                        Select
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <p className="label-text-small">
          * The returns displayed above reflect the high and low typical ranges
          of the rolling 12 month averages from December 31, 1990 through
          December 31, 2017 for six hypothetical portfolios of global stocks and
          bonds. These returns do not reflect the performance of actual
          investment accounts and are presented for illustrative purposes only.
          Past performance is not a guarantee of future results.
        </p>
        <BackNextSkip
          backButtonClassName={'button button-secondary button-lg'}
          backButtonText={'BACK'}
          onBackButtonClickHandler={this.props.onBackButtonClick}
          nextButtonClassName={
            'button button-primary button-lg ml-2 ' +
            (selected && selected !== 0 ? '' : 'disabled')
          }
          nextButtonText={'NEXT'}
          onNextButtonClickHandler={this.props.onNextButtonClick}
          // skipText={"Assert Risk"}
          onSkipClickHandler={this.props.onSkipButtonClick}
        />
      </div>
    );
  }
  // private goToRiskClick() {
  // 	this.props.riskActions.GetRiskQuestions(ERiskQuestionnaireType.AssertRisk, this.props.appState.InvestorId, this.props.appState.ClientWebId);
  // 	redirectTo(this.props.history, "/riskassert/");
  // }

  private selectInvestmentRange(barIndex) {
    this.setState({
      barRangeSelected: barIndex,
    });
  }

  // private onBackButtonClick() {
  // 	// going back to goals last screen
  // 	redirectTo(this.props.history, `/goals/${GetSideBarMenuItem(EMenubarType.YourGoals, EGoalSideBarType.AnnualContributions).Key}`);
  // }

  // private onNextButtonClick(event) {
  // 	const selected = (!this.state.barRangeSelected) ? this.props.data.selectedChoiceId : this.state.barRangeSelected;
  // 	if (event.target &&
  // 		event.target.classList &&
  // 		event.target.classList.contains("disabled")) {
  // 		event.preventDefault();
  // 	} else {
  // 		const data = {
  // 			selectedChoice: selected,
  // 			sequence: ERiskSideBarType.InvestmentReturn
  // 		};
  // 		const forwardPath = `/risk/${GetSideBarMenuItem(EMenubarType.RiskProfile, ERiskSideBarType.MaximumDecline).Key}`;
  // 		this.props.updateRiskState(data, forwardPath);
  // 	}
  // }

  private getInvestmentReturnModelsFromChoices(
    investmentAmount: number,
    data: TAssessRiskProfile[],
    choices: TRiskChoice[],
  ) {
    if (!choices || choices.length === 0) {
      return [];
    }

    return data.map((ret, index) => {
      if (ret.gainLoss) {
        return {
          Key: choices[index] ? choices[index].choiceId : index,
          Gain: (investmentAmount * ret.gainLoss.gainPercent) / 100,
          GainPercent: ret.gainLoss.gainPercent,
          Loss: (investmentAmount * ret.gainLoss.lossPercent) / 100,
          LossPercent: ret.gainLoss.lossPercent,
          AverageReturn:
            (investmentAmount * ret.gainLoss.longTermAveragePercent) / 100,
          AverageReturnPercent: ret.gainLoss.longTermAveragePercent,
        };
      } else {
        return {
          Key: choices[index] ? choices[index].choiceId : index,
          Gain: investmentAmount / 100,
          GainPercent: 0,
          Loss: investmentAmount / 100,
          LossPercent: 0,
          AverageReturn: investmentAmount / 100,
          AverageReturnPercent: 0,
        };
      }
    });
  }
}

// InvestmentReturnComponent.defaultProps = {
//   barRangeSelected: false,
// };
